import { Product } from "../types";

/**
 * Get all category IDs this product belongs to
 */
export function getAllCategoryIds(product: Product): string[] {
  return [product.categoryId].filter((id): id is string => !!id);
}

/**
 * Check if product belongs to a specific category
 */
export function belongsToCategory(
  product: Product,
  categoryId: string,
): boolean {
  return getAllCategoryIds(product).includes(categoryId);
}

/**
 * Get display price (formatted)
 */
export function formatPrice(price: number): string {
  return price.toLocaleString("ko-KR") + "원";
}

/**
 * Calculate discount rate between master price and supplier price
 */
export function calculateDiscountRate(
  masterPrice: number,
  myPrice: number,
): {
  rate: number;
  formattedRate: string;
  isDiscount: boolean;
  isPremium: boolean;
} {
  if (masterPrice <= 0 || myPrice <= 0) {
    return { rate: 0, formattedRate: "0", isDiscount: false, isPremium: false };
  }

  const rate = ((masterPrice - myPrice) / masterPrice) * 100;

  return {
    rate,
    formattedRate: rate.toFixed(1),
    isDiscount: rate > 0,
    isPremium: rate < 0,
  };
}

/**
 * Check for abnormal price (e.g., 50% cheaper than master price)
 */
export function isAbnormalPrice(
  masterPrice: number,
  myPrice: number,
  thresholdPercent = 50,
): boolean {
  if (masterPrice <= 0 || myPrice <= 0) return false;
  // If myPrice is less than 50% of masterPrice
  return myPrice < masterPrice * (thresholdPercent / 100);
}
